import React, { useCallback } from "react";
import { List, Skeleton } from "antd";
import SinglePostScreen from "Pages/MyBatches/Channels/ChannelComponents/SinglePostScreen";
import { debounce } from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import useMasterContext from "Context/MasterContext";

export interface Post {
  id?: number;
  batchId?: number;
  title: string;
  description: string;
  updatedAt: string;
  status: string;
  subject?: string;
  createdBy?: string;
  commentCount?: number;
  likesCount?: number;
  postType?: string;
}

interface RecentPostsProps {
  posts: Post[];
  handlePostSelect: (post: Post) => void;
  handleEditPost: (post: Post) => void;
  handleDeletePost: (postId: string) => void;
  handleIncrementCommentCount: (postId: string) => void;
  handleDecrementCommentCount: (postId: string) => void;
  loading: boolean;
  selectedPost?: Post;
  hasMore: boolean;
  next: () => void;
  hasFullAccess?: boolean;
}

const RecentPosts: React.FC<RecentPostsProps> = ({
  posts,
  handlePostSelect,
  handleEditPost,
  handleDeletePost,
  handleIncrementCommentCount,
  handleDecrementCommentCount,
  loading,
  hasMore,
  next,
  hasFullAccess,
}) => {
  const { masters, saveMasterData } = useMasterContext();
  const { unreadComments } = masters || {};
  const handleNext = () => {
    console.log("Loading:", loading, "HasMore:", hasMore);
    if (!loading && hasMore) {
      next();
    }
  };
  const debouncedNext = useCallback(
    debounce(() => {
      handleNext();
    }, 100), // 500ms debounce
    [loading, hasMore, next]
  );
  console.log(
    "RecentPosts render - posts:",
    posts,
    "loading:",
    loading,
    "hasMore:",
    hasMore
  );
  return (
    <InfiniteScroll
      dataLength={posts.length}
      next={debouncedNext}
      hasMore={hasMore}
      loader={loading && <Skeleton active />}
      style={{ overflowX: "hidden" }}
    >
      <List
        grid={{ gutter: 16, xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }}
        dataSource={posts}
        style={{ marginTop: "2px" }}
        renderItem={(item) => (
          <List.Item key={item.id ?? item.title}>
            <SinglePostScreen
              post={item}
              allPosts={posts}
              handlePostSelect={handlePostSelect}
              handleEditPost={handleEditPost}
              handleDeletePost={handleDeletePost}
              handleIncrementCommentCount={handleIncrementCommentCount}
              handleDecrementCommentCount={handleDecrementCommentCount}
              hasFullAccess={hasFullAccess}
              onCommentsFetched={(data) => {
                console.log(data);
                const batchId = item?.batchId;
                const postId = item?.id;
                const subjectName = item?.subject;

                if (unreadComments && batchId && postId) {
                  const updatedUnreadComments = unreadComments.map(
                    (batch: any) => {
                      if (batch.batchId === batchId) {
                        return {
                          ...batch,
                          subjects: batch.subjects.map((s: any) => {
                            if (s.subject === subjectName) {
                              return {
                                ...s,
                                postIds: s.postIds.filter(
                                  (id: any) => id !== postId
                                ),
                              };
                            }
                            return s;
                          }),
                        };
                      }
                      return batch;
                    }
                  );
                  saveMasterData({ unreadComments: updatedUnreadComments });
                }
              }}
            />
          </List.Item>
        )}
      />
    </InfiniteScroll>
  );
};

export default RecentPosts;
